<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>供应系统</el-breadcrumb-item>
        <el-breadcrumb-item>商品管理</el-breadcrumb-item>
        <el-breadcrumb-item>库存调配统计</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <hx-table-result :page-info="pager" :loading="tableLoading" @page-current-change="handleCurrentChange" @page-size-change="handleSizeChange">
      <div slot="action"></div>

      <hx-table-result-col>
        <div class="wrap-table-info-display" style="height: 32px">
          <span class="table-info-display">
            <span>总条数：</span>
            <span class="alert-text ft16">{{ pager.total }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <el-table slot="content" :data="pager.data" max-height="800" border>
        <icTableColumnIndex :pageIndex="pager.pageIndex" :pageSize="pager.pageSize" />

        <el-table-column prop="goodTitle" align="center" label="菜品名称" />
        <el-table-column prop="AdjustTime" align="center" label="调配时间" />
        <el-table-column prop="supplyData" align="center" label="领货日期" />
        <el-table-column prop="oldLevelStock" align="center" label="原有库存" />
        <el-table-column prop="adjustStock" align="center" label="调配数量" />
        <el-table-column prop="adjustAfterStock" align="center" label="调配后库存" />
        <el-table-column prop="adjustPlaLogisticsSiteId" align="center" label="库存调配方" />
        <el-table-column prop="receivePlaLogisticsSiteId" align="center" label="库存接收方" />
        <el-table-column prop="adjustLevelId" align="center" label="调配方等级" />
        <el-table-column prop="receiveLevelId" align="center" label="接受方等级" />
      </el-table>
    </hx-table-result>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0,
        data: [],
      },
      tableLoading: false,
    };
  },
  mounted() {
    this.loadTableData();
  },
  methods: {
    loadTableData() {
      this.$http({
        url: global.apiUrl + "/supply/good/adjust/flow",
        method: "GET",
        params: {
          pageIndex: this.pager.pageIndex,
          pageSize: this.pager.pageSize,
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            if (res.body.data) {
              this.pager.data = res.body.data.data;
              this.pager.total = res.body.data.total;
            } else {
            }
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    },
  },
};
</script>

<style></style>
